import { render, staticRenderFns } from "./SelectReplacement.vue?vue&type=template&id=80996e20&"
import script from "./SelectReplacement.vue?vue&type=script&lang=js&"
export * from "./SelectReplacement.vue?vue&type=script&lang=js&"
import style0 from "./SelectReplacement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports